import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { NgxAnalyticsGoogleAnalytics } from 'ngx-analytics/ga';

const googleAnalytics = {
  domain: 'auto',
  trackingId: environment.gaKey 
};

declare global {
  interface Window {
      sdkPtr: any;  
      JSONreq: any;
    }
}
NgxAnalyticsGoogleAnalytics.prototype.createGaSession(googleAnalytics); 

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
